export const CATEGORY_ALL_COVER_IMAGE_URL =
  'https://raize.sfo2.cdn.digitaloceanspaces.com/cookbook/covers/allMeals.jpg';
export const CATEGORY_ALL_NAME = 'cookbook.mealCategoryThumb.allMealsTitle';
